import { Level } from "@tiptap/extension-heading";

export const titleVariantMap: Record<string, Level> = {
    h1: 1,
    h2: 2,
    h3: 3,
    h4: 4,
    h5: 5,
};